module.exports = __webpack_public_path__ + "img/Graph-6.f9836853.svg";